import React, {Component} from 'react';
import { Container, Row, Col } from 'reactstrap';
import { sendData } from '../../analytics/sendData';
import { FormattedMessage } from 'react-intl';
import {config} from './../../constants/domainConfig'
import { isGamiclub } from '../../constants/isGamiclub';
class AGB extends Component {

	componentDidMount() {
        sendData('', '', '', 'viewed', { page: 'agb' });
		window.scrollTo(0, 0);
	}

	render() {
        return (
		<section className="terms privacy-policy">
			<Container fluid>
				<Row>
					<Col xs="12">
						<div className="terms-title-wrap">
							<h2 className="terms-section-title">
                                Geschäftsbedingungen
                            </h2>
						</div>
					</Col>
				</Row>
				<Row className="no-gutters">
					<Col xs="12" className="terms-list">
                        <p className="terms-para">
                            AGB
                        </p>
                    </Col>
                    <Col xs="12" className="terms-list">
                        <h6 className="terms-title">
                            1. Geltungbereich
                        </h6>
                        <p className="terms-para">
                            Die nachstehenden Allgemeinen Geschäftsbedingungen sind Bestandteil eines jeden Vertrags zwischen der, Sam Media (im Folgenden: Anbieter) und dem Nutzer der Leistungen des Anbieters. An diese Allgemeinen Geschäftsbedingungen sind auch die Rechtsnachfolger des Anbieters sowie die des Nutzers gebunden.
                        </p>
                        <p className="terms-para">
                            Der Anbieter stellt dem Nutzer gegen Entgelt die Möglichkeit zur Verfügung, die auf der Webseite angebotenen Inhalte über sein mobiles Endgerät (Mobiltelefon) abzurufen und zu nutzen. Gegenstand dieser Allgemeinen Geschäftsbedingungen sind sämtliche diesbezüglich zwischen den Vertragsparteien zu treffende Regelungen.
                        </p>
                        <p className="terms-para">
                            Diese Allgemeinen Geschäftsbedingungen gelten ausschliesslich für Nutzer aus der Schweiz.
                        </p>
                        <p className="terms-para">
                            Der Anbieter erbringt seine Leistungen ausschliesslich auf der Grundlage dieser Allgemeinen Geschäftsbedingungen.
                        </p>
                        <p className="terms-para">
                            Die Gültigkeit dieser Allgemeinen Geschäftsbedingungen erstreckt sich auf alle auf der Webseite angebotenen Leistungen des Anbieters. Der Nutzer erkennt mit der Inanspruchnahme der Leistungen des Anbieters diese Allgemeinen Geschäftsbedingungen als für ihn verbindlich an.
                        </p>
                    </Col>
                    <Col xs="12" className="terms-list">
                        <h6 className="terms-title">
                            2. Vertragsschluss
                        </h6>
                        <p className="terms-para">
                            Die Präsentation der Leistungen des Anbieters auf der Webseite von stellt noch kein bindendes Angebot des Anbieters, sondern lediglich eine Aufforderung zur Abgabe eines Angebots durch den Nutzer dar.
                        </p>
                        <p className="terms-para">
                            Der Vertrag kommt durch die Aktivierung des auf dem mobilen Endgerät des Nutzers nach Aufruf einer Leistung des Anbieters angezeigten Bestätigungs- bzw. Abspielbuttons durch den Nutzer und die darauf folgende Einrichtung der Geschäftsbedingungen der Leistungen durch den Anbieter zustande.
                        </p>
                        <p className="terms-para">
                            Der Nutzer kann unmittelbar nach der Einrichtung der Nutzungsmöglichkeit sämtliche auf der Webseite angebotenen Leistungen über sein mobiles Endgerät abrufen und nutzen.
                        </p>
                        <p className="terms-para">
                            Es gelten die dem Nutzer mitgeteilten Preise. Diese beinhalten die gesetzliche Mehrwertsteuer, gelten für den jeweils angegebenen Zeitraum und beziehen sich lediglich auf die Einräumung der Nutzungsmöglichkeit der Leistungen des Anbieters. Nicht von den Preisen umfasst sind im Rahmen des Abrufs der Leistungen des Anbieters entstehende Verbindungsgebühren, die dem Nutzer von seinem Mobilfunkanbieter berechnet werden.
                        </p>
                        <p className="terms-para">
                            Das seitens des Nutzers für die Inanspruchnahme der Leistungen des Anbieters zu entrichtende Entgelt wird sofort mit Vertragsschluss und ohne Abzug fällig. Dieses Entgelt wird im Auftrag des Anbieters seitens des Mobilfunkanbieters des Nutzers im Rahmen der turnusmässigen Abrechnung eingezogen.
                        </p>
                        <p className="terms-para">
                            Der Nutzer erhält an den von dem Anbieter zur Verfügung gestellten Leistungen ein einfaches, nicht übertragbares, zeitlich auf die Dauer dieses Vertrags begrenztes, örtlich unbeschränktes Nutzungsrecht.
                        </p>
                    </Col>
                    <Col xs="12" className="terms-list">
                        <h6 className="terms-title">
                            3. Zahlungsbedingungen
                        </h6>
                        <p className="terms-para">
                            Es gelten die dem Nutzer mitgeteilten Preise. Diese beinhalten die gesetzliche Mehrwertsteuer, gelten für den jeweils angegebenen Zeitraum und beziehen sich lediglich auf die Einräumung der Nutzungsmöglichkeit der Leistungen des Anbieters. Nicht von den Preisen umfasst sind im Rahmen des Abrufs der Leistungen des Anbieters entstehende Verbindungsgebühren, die dem Nutzer von seinem Mobilfunkanbieter berechnet werden.
                        </p>
                        <p className="terms-para">
                            Das seitens des Nutzers für die Inanspruchnahme der Leistungen des Anbieters zu entrichtende Entgelt wird sofort mit Vertragsschluss und ohne Abzug fällig. Dieses Entgelt wird im Auftrag des Anbieters seitens des Mobilfunkanbieters des Nutzers im Rahmen der turnusmässigen Abrechnung eingezogen.
                        </p>
                    </Col>
                    <Col xs="12" className="terms-list">
                        <h6 className="terms-title">
                            4. Nutzungsrechte
                        </h6>
                        <p className="terms-para">
                            Der Nutzer erhält an den von dem Anbieter zur Verfügung gestellten Leistungen ein einfaches, nicht übertragbares, zeitlich auf die Dauer dieses Vertrags begrenztes, örtlich unbeschränktes Nutzungsrecht.
                        </p>
                    </Col>
                    <Col xs="12" className="terms-list">
                        <h6 className="terms-title">
                            5. Erreichbarkeit
                        </h6>
                        <p className="terms-para">
                            Der Anbieter gewährleistet eine Erreichbarkeit der von ihm zur Verfügung gestellten Leistungen von 99,5 % im Jahresdurchschnitt. Sollte eine solche Erreichbarkeit nicht gegeben sein, kann der Nutzer gegenüber dem Anbieter ein Minderungsrecht geltend machen. Dieses ist der Höhe nach auf den Betrag begrenzt, den der Nutzer während des Zeitraums, in dem die gewährleistete Erreichbarkeit nicht vorlag, aufgrund dieses Vertrags zu entrichten hatte.
                        </p>
                        <p className="terms-para">
                            Der Anbieter gestaltet sein Angebot unter Einhaltung der am Markt vorhandenen technischen Standards und versucht hierdurch sicher zu stellen, dass der Nutzer die Leistungen des Anbieters in Anspruch nehmen kann. Der Anbieter kann jedoch nicht garantieren, dass die von ihm angebotenen Leistungen mittels sämtlicher am Markt befindlicher mobiler Endgeräte abrufbar sind.
                        </p>
                    </Col>
                    <Col xs="12" className="terms-list">
                        <h6 className="terms-title">
                            6. Haftungsbeschränkung / Haftungsfreistellung
                        </h6>
                        <p className="terms-para">
                            Für andere als durch Verletzung von Leben, Körper und Gesundheit entstehende Schäden haftet der Anbieter lediglich, soweit diese auf vorsätzlichem oder grob fahrlässigem Verhalten des Anbieters, seiner Mitarbeiter oder seiner Erfüllungsgehilfen beruhen. Dies gilt auch für Schäden aus der Verletzung von Pflichten bei Vertragsverhandlungen sowie aus der Vornahme von unerlaubten Handlungen. Eine darüber
                        </p>
                    </Col>
				</Row>
			</Container>
		</section>
        );
	}
}
export default AGB;



// WEBPACK FOOTER //
// ./src/components/StaticPages/AGB.js